/**
 * @generated SignedSource<<205149e295fd98f58ebae9d4cf9a142d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type searchExploreKeyAnglesArticleSearchResultStreamItemCategory$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"itemSearchExploreKeyAnglesItemArticleSearchResultStreamItemCategory">;
  readonly " $fragmentType": "searchExploreKeyAnglesArticleSearchResultStreamItemCategory";
}>;
export type searchExploreKeyAnglesArticleSearchResultStreamItemCategory$key = ReadonlyArray<{
  readonly " $data"?: searchExploreKeyAnglesArticleSearchResultStreamItemCategory$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchExploreKeyAnglesArticleSearchResultStreamItemCategory">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "searchExploreKeyAnglesArticleSearchResultStreamItemCategory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "itemSearchExploreKeyAnglesItemArticleSearchResultStreamItemCategory"
    }
  ],
  "type": "ArticleSearchResultStreamItemCategory",
  "abstractKey": null
};

(node as any).hash = "046085b614da77a3cce3dded4471b9f3";

export default node;
